import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=a38b73a0&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/game/Dev/frontend/liff/veranda-booking2/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VImg,VLayout})
